// extracted by mini-css-extract-plugin
export const news = "B_v";
export const forArticle = "B_w";
export const news_heading = "B_x";
export const news_btn = "B_y";
export const news_wrap = "B_z";
export const news_list = "B_B";